angular.module('ui.user', [
    'ui.user.notifications',
    'ui.user.profile',
    'ui.user.settings'
]);